import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n, t } = useTranslation('shared');

  const languages = [
    { code: 'pl', name: t('language.pl'), flag: '🇵🇱' },
    { code: 'en', name: t('language.en'), flag: '🇬🇧' },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      {languages.map((lang) => (
        <button
          key={lang.code}
          className={`lang-button ${i18n.language === lang.code ? 'active' : ''}`}
          onClick={() => changeLanguage(lang.code)}
          title={t('language.switch')}
        >
          <span className="lang-flag" aria-hidden>{lang.flag}</span>
          <span className="lang-label">{lang.name}</span>
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;






